import { render } from "./AnnouncementViewsDialog.vue?vue&type=template&id=61079c6a"
import script from "./AnnouncementViewsDialog.vue?vue&type=script&lang=js"
export * from "./AnnouncementViewsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__